//DESA
//export const WEB_AUTH_URL = "http://localhost:8081";
//export const WEB_CORE_URL = "http://localhost:3000";
//export const PARAM_NAME_COOKIEDOMAIN = "localhost";

//QA API GATEWAY
//export const WEB_AUTH_URL = "https://auth.qasg3plus.com";
//export const WEB_CORE_URL = "https://qasg3plus.com";
//export const PARAM_NAME_COOKIEDOMAIN = ".qasg3plus.com";

//PRD
export const WEB_AUTH_URL = "https://auth.sg3plus.com";
export const WEB_CORE_URL = "https://sg3plus.com";
export const PARAM_NAME_COOKIEDOMAIN = ".sg3plus.com";

export const RECAPTCHA_SITE_KEY = "6LfR-40pAAAAAK3wzg59mkCgZ3dgLgDvK5ToYP7h"
//export const AZURE_ENTRA_CLIENT_ID = "80a230b3-edfa-429f-91ab-f7c7fb5aaa6f"
export const AZURE_ENTRA_CLIENT_ID = "7b616d56-c69b-4a37-8928-bc24640e37d6"
